import styled from "styled-components";

import Icon from "../../_static/Icons";
import { buildText } from "../../_atom/Text";

import buildColor from "../../_static/ColorPalette";
import { defaultSize, fontNormal, fontMedium } from "../../_static/Typography";

export const List = styled.ol`
  padding: 0;
  margin: 0;
  list-style: none;
`;

export const ListItem = styled.li`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
`;

export const Time = styled.time`
  color: ${buildColor("grey", "800")};
  white-space: nowrap;
  font-family: ${fontNormal};
  font-style: normal;
  font-weight: normal;
  font-size: ${defaultSize};
  line-height: 18px;
`;

export const ArrowIcon = styled(Icon)`
  margin: 0 4px;
  align-items: center;
`;

export const InfoField = styled(
  buildText({
    tag: "span",
    fontSize: 14,
    color: buildColor("grey", "800")
  })
)`
  font-family: ${fontNormal};
  font-weight: normal;
  font-style: normal;
  line-height: 18px;
  white-space: nowrap;
`;

export const RaceChange = styled(InfoField)`
  margin-left: 4px;
  min-width: 62px;
  font-family: ${fontMedium};
  font-weight: 500;
  line-height: 19px;
`;

export const RaceChangeWrapper = styled.div`
  margin-left: 6px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const OldValue = styled(InfoField)`
  min-width: 30px;
`;

export const NewValue = styled(InfoField)`
  min-width: 30px;
  font-family: ${fontMedium};
  font-weight: 500;
  line-height: 19px;
  color: ${buildColor("orange", "800")};
`;

export const ShowMoreLink = styled.button`
  margin-top: 10px;
  font-family: ${fontMedium};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${buildColor("blue_accent", "500")};
  background-color: transparent;
  outline: none;
  cursor: pointer;
`;
